module.exports = __webpack_public_path__ + "static/media/bg-support-characters.925155ba.svg";